import { ArrowLeft, Filter2 } from "@css/icons/SVG"
import React from "react"
import { Modal } from "antd"
import { maskStyle } from "@css/js-style"
import * as ReactDOM from "react-dom"
import { store } from "@utils/store"
import styles from "@css/modules/PointChart.module.scss"
import cn from "classnames"

export class MobileFilters extends React.PureComponent {
    state = {
        isOpen: false,
        isReady: false
    }

    componentDidMount() {
        this.portalTarget = document.getElementById("headerInject")
        this.unwatch = store.watch(store.k.headerReady, this.onHeaderReady)
        this.onHeaderReady(store.get(store.k.headerReady))
    }

    componentWillUnmount() {
        this.unwatch()
    }

    onHeaderReady = (isReady) => {
        this.setState({
            isReady
        })
    }

    openModal = () => {
        this.setState({
            isOpen: true
        })
    }
    closeModal = () => {
        this.setState({
            isOpen: false
        })
    }

    portalRenderer() {
        const { isOpen } = this.state
        return (
            <>
                <button className={styles.mobileFilterBtn} onClick={this.openModal}>
                    <Filter2 />
                </button>
                {isOpen && (
                    <Modal
                        maskStyle={maskStyle}
                        wrapClassName={styles.loginModalWrap}
                        className={cn(styles.filtersModal, styles.mobile)}
                        width={336}
                        closeIcon={() => {}}
                        centered
                        open={isOpen}
                        maskClosable
                        onCancel={this.closeModal}
                        footer={null}>
                        <button onClick={this.closeModal} className={styles.arrowBack}>
                            <ArrowLeft />
                        </button>
                        <div className={styles.modalContent}>
                            <h3 className={styles.filtersTitle}>Filters</h3>
                            {this.props.children}
                        </div>
                    </Modal>
                )}
            </>
        )
    }

    render() {
        if (!this.state.isReady) {
            return null
        }
        return ReactDOM.createPortal(this.portalRenderer(), this.portalTarget)
    }
}
